<template>
  <div>
    <div class="gift">
      <div class="title">
        <span>版本更新礼</span>
        <i class="iconfont yw-guanbi1" @click="closeConfirm"></i>
      </div>
      <div class="updateText">
        <img :src="`${$cdnLink}/update/fangkuai.png`" />
        <span>您已成功更新游戏版本，我们为您准备了以下好礼,快去游戏中领取吧。</span>
      </div>
      <div class="updateGift">
        <div class="giftImg">
          <img :src="item" v-for="(item, index) in update_gift_icon" :key="index" />
        </div>
        <div class="giftCode">
          <span>礼包码：</span>
          <span>{{ update_gift_code }}</span>
        </div>
      </div>
      <p class="updateHint">
        您可点击下方复制按钮，复制礼包码；您也可以
        <span>截图保存礼包码</span>，然后在游戏中找到礼包码兑换入口，输入礼包码后即可获得上述的全部奖励。如有任何问题，请联系客服。
      </p>
      <button class="copyBtn" :data-clipboard-text="update_gift_code">复制</button>
    </div>
    <div class="hint" v-if="hintShow">
      <div class="title">提示</div>
      <div class="content">
        <p>请确认礼包码是否已复制？</p>
        <div class="code">{{ update_gift_code }}</div>
      </div>
      <div class="btn">
        <button @click="hintShow = false">取消</button>
        <button class="confirm" @click="close">确认</button>
      </div>
    </div>
  </div>
</template>
<script>
import { getStorage } from '@/libs/utils';
import ClipboardJS from 'clipboard';
import { Toast } from 'vant';

export default {
  data() {
    return {
      copyEl: null,
      hintShow: false,
      update_gift_icon: '',
      update_gift_code: []
    }
  },
  mounted() {
    this.update_gift_icon = getStorage('update_gift_icon');
    this.update_gift_code = getStorage('update_gift_code');
    this.copyEl = new ClipboardJS('.copyBtn');
    this.copyEl.on('success', (e) => {
      Toast('您已成功复制礼包码');
    }); 
  },
  beforeDestroy() {
    this.copyEl && this.copyEl.destroy(); 
  },
  methods: {
    close() {
      this.$emit('close')
    },
    closeConfirm() {
      this.hintShow = true;
    }
  },
}
</script>

<style lang="scss" scoped>
.gift {
  width: 417px;
  height: 313px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 6px;
  background-color: #FFFFFF;
  font-size: 11px;
  z-index: 99;
  @media screen and (orientation: portrait) {
    width: 370px;
    height: 350px;
  }
  .title {
    height: 38px;
    width: 100%;
    color: #ff4f3e;
    font-weight: 500;
    font-style: italic;
    font-size: 16px;
    line-height: 38px;
    padding-left: 10px;
    background: url("#{$cdn-url}/update/header.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    @media screen and (orientation: portrait) {
      background: url("#{$cdn-url}/update/header.png") no-repeat;
      background-size: 100% 100%;
       font-size: 14px;
    }
    > .iconfont {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 16px;
      color: #FFFFFF;
    }
  }
  .updateText {
    display: flex;
    align-items: flex-start;
    margin: 15px 0 10px 0;
    padding: 0 30px;
    > img {
      width: 6px;
      height: 6px;
      margin: 2px 5px 0 2px;
    }
  }
  .updateGift {
    width: 337px;
    height: 143px;
    background: #f5f3f0;
    margin: auto;
    padding-top: 10px;
    border-radius: 3px;
    margin-bottom: 15px;
    .giftImg {
      display: flex;
      justify-content: center;
      margin-bottom: 18px;
      > img {
        display: inline-block;
        width: 44px;
        max-height: 70px;
        margin: 0 5px;
      }
    }
    .giftCode {
      margin: auto;
      width: 200px;
      height: 35px;
      background: #E3E3E3;
      border-radius: 17px;
      line-height: 35px;
      padding-left: 15px;
      > span:nth-child(1) {
        color: #FB6565;
        font-size: 14px;
        font-weight: bold;
      }
      > span:nth-child(2) {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .updateHint {
    padding: 0 33px;
    color: #999999;
    font-size: 9px;
    line-height: 11px;
    > span {
      color: #FF5040;
    }
  }
  .copyBtn {
    display: block;
    border: none;
    width: 136px;
    height: 35px;
    background: linear-gradient(90deg, #FF6C5E 0%, #FF6254 100%);
    box-shadow: 0px 5px 18px 0px rgba(255, 98, 84, 0.45);
    border-radius: 17px;
    color: #FFFFFF;
    font-size: 13px;
    margin: 10px auto 0;
    &:active {
      opacity: 0.9;
    }
  }
}
.hint {
  width: 270px;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 6px;
  z-index: 100;
  background-color: #FFFFFF;
  font-size: 11px;
  box-shadow: 0px 0px 41px 0px rgba(129, 129, 129, 0.72);
  border-radius: 6px;
  .title {
    font-weight: bold;
    color: #FF5141;
    line-height: 14px;
    text-align: center;
    margin: 9px 0 6px 0;
    font-size: 14px;
  }
  .content {
    width: 214px;
    height: 72px;
    background: #F4F2EF;
    border-radius: 3px;
    padding-top: 15px;
    color: #333333;
    font-size: 10px;
    margin-bottom: 10px;
    text-align: center;
    margin: auto;
    .code {
      font-size: 13px;
      font-weight: bold;
      color: #FF5645;
      line-height: 15px;
      margin-top: 14px;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    margin-top: 7px;
    > button {
      margin: 0 10px;
      width: 88px;
      height: 28px;
      border: 1px solid #FF6B5E;
      box-shadow: 0px 5px 18px 0px rgba(255, 98, 84, 0.45);
      border-radius: 14px;
      color: #FF6456;
      background: #FFFFFF;
    }
    .confirm {
      background: linear-gradient(90deg, #FF6C5E 0%, #FF6254 100%);
      color: #FFFFFF;
    }
  }
}
</style>